const dataStore = {

    questionType: null,

    activeType: "map",
    activeScaleType : 'DEFAULT', // CUSTOM

    addLicense : null,

    errors: {},
    errorsAdmin: [],
    showMediaPopup: false,
    showFindPlace: false,
    activeIndex: null,

    popUpMediaFile: false,
    activeFileName: "",
    activeQuestion: "",
    activeVideoUrl: "",
    typeOfVideo : 0,
    active3dIframe: "",
    amountAnswers : 5,
    editMode: false,
    projectItems: [],

    center: "", // not sure if its in use anymore?



    mapSearch : false,

    disableMapEditor: true,

    showInfoBoxEditor: false,

    allowUploadImage: true,

    allowMultiAnswersScale: false,

    allowLimitMarkers : false,

    allowGoodOptions : false,
    allowBadOptions : false,

    // maps
    activeMapObj: {
        centerLat: 61.6706531,
        centerLng: 18.687777,
        paths: []
    },

    message: "",
    showMessage: false,
    messageSuccess: null,

    isDeletingImage: false,
    isDeletingImageLogo: false,

    addGoodOption: "",
    addBadOption: "",
    addScaleOption: "",
    addCounty: "",
    addAge: "",
    addType: "",
    addGender: "",
    searchAndAddValue: "",

    hint : '',

    responseFormDescription : '',

    showProjectStatePopUp: false,

    currentProjectID: null,
    hideEditStateView: false,

    currentStateToEdit: {
        index: null,
        state: null
    },

    isLoaded: false,

    project: {
        isPublic: 0,
        allowToEdit: false,
        projectLevel: 'BAS',
        slug: '',
        projectName: '',
        logoInsteadOfName: false,
        currentImageName: '',
        currentProjectState: '',
        startDate: false,
        endDate: false,
        image: false,
        updateSlug: false,
        imageLogoInstead: null,
        currentImageNameLogoInstead: '',
        customer: '',
        projectUrl: '',
        address: '',
        textUrl: '',
        mapLink: '',
        beforeText: '',
        welcomeText: '',
        endText: '',
        thank_you_title: '',
        thank_you: '',
        terms: '',
        currentUrl: '',
        guid: '',

        language : 'en',

        projectState: [
            {
                name: "",
                link: ""
            },
            {
                name: "",
                link: ""
            },
            {
                name: "",
                link: ""
            },
            {
                name: "",
                link: ""
            },
            {
                name: "",
                link: ""
            }
        ],

        goodOptions: [],
        badOptions: [],
        scaleOptions: [],

        types: [],

        ages: [
            {age: '0-9', sort : 0},
            {age: '10-19', sort: 1},
            {age: '20-29', sort: 2},
            {age: '30-39', sort: 3},
            {age: '40-49', sort: 4},
            {age: '50-59', sort: 5},
            {age: '60-69', sort: 6},
            {age: '70-79', sort: 7},
            {age: '80-', sort: 8},
        ],

        counties: [],

        genders: [],

        allowGoodOptions: true,
        allowBadOptions: true,

        // allowScaleOptions : false,
        allowTypes: true,
        allowAges: true,
        allowCounties: true,
        allowGenders: true,
        hideMapLink: false,

        // Q&A / FAQ toggle
        allowFaq: false,

        spamProtection: false,

        faqEmail: '',

        showOptions: {

            hide_report: {
                id: 1,
                model: "hide_report",
                allow: true,
                name: "Anmäl-knapp"
            },

            hide_share: {
                id: 2,
                model: "hide_share",
                allow: true,
                name: "Dela-knapp"
            },

            hide_continue_discussion: {
                id: 3,
                model: "hide_continue_discussion",
                allow: true,
                name: "Fortsatt diskussion"
            },

            newsletter: {
                id: 4,
                model: "newsletter",
                allow: false,
                name: "Nyhetsbrev"
            },

        },

        allowOptions: {

            hide_name: {
                id: 5,
                model: "hide_name",
                allow: false,
                name: ''
            },

            hide_address: {
                id: 6,
                model: "hide_address",
                allow: false,
                name: ''
            },

            hide_email: {
                id: 7,
                model: "hide_email",
                allow: false,
                name: ''
            },

            // hide_extra_information : {
            //     id : 10,
            //     model : 'hide_extra_information',
            //     allow : false,
            //     name : 'Övrig information'
            // },

            hide_terms: {
                id: 8,
                model: "hide_terms",
                allow: false,
                name: ''
            }

        },

        addressZoom: 6,

        addressMapCenter: null,
        
    }
};

export default dataStore;
